export const formatNumbersForShare = (numbers, superzahl) => {
  const numbersStr = numbers.join(', ');
  const websiteUrl = 'https://lottozahlen-generator.net';
  return `Meine Lottozahlen: ${numbersStr} + Superzahl: ${superzahl}\n\nGeneriert auf ${websiteUrl}`;
};

export const formatNumbersForClipboard = (numbers, superzahl) => {
  const numbersStr = numbers.join(', ');
  return `Meine Lottozahlen: ${numbersStr} + Superzahl: ${superzahl}`;
};

export const getShareUrl = (numbers, superzahl) => {
  const params = new URLSearchParams({
    numbers: numbers.join(','),
    superzahl: superzahl.toString()
  });
  return `${window.location.origin}${window.location.pathname}?${params.toString()}`;
};

export const getFacebookShareUrl = (numbers, superzahl) => {
  const url = encodeURIComponent(getShareUrl(numbers, superzahl));
  const text = encodeURIComponent(formatNumbersForShare(numbers, superzahl));
  return `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`;
};

export const getTwitterShareUrl = (numbers, superzahl) => {
  const text = encodeURIComponent(formatNumbersForShare(numbers, superzahl));
  const url = encodeURIComponent(getShareUrl(numbers, superzahl));
  return `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
};

export const getWhatsAppShareUrl = (numbers, superzahl) => {
  const text = encodeURIComponent(formatNumbersForShare(numbers, superzahl));
  const url = encodeURIComponent(getShareUrl(numbers, superzahl));
  return `https://wa.me/?text=${text}%20${url}`;
};

export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        document.body.removeChild(textArea);
        return true;
      } catch (err) {
        document.body.removeChild(textArea);
        return false;
      }
    }
  } catch (error) {
    console.error('Error copying to clipboard:', error);
    return false;
  }
};


